
    var riot = require('riot')
    
riot.tag2('interpreter-appointments', '<div show="{!appointments}" class="alert alert-info">Loading Appointments</div> <div show="{appointments.length == 0}" class="alert alert-info">You have no appointments at this time.</div> <div show="{appointments.length &gt; 0}" class="table-responsive"> <table class="table table-striped"> <thead> <tr> <th>Ref</th> <th>Booking For</th> <th>When</th> <th>Approx Duration</th> <th>Venue</th> <th>Status</th> <td>Actions</td> </tr> </thead> <tbody> <tr each="{appointments}"> <td> {(⁗0000000000⁗+id).substr(-4)} </td> <td>{name}</td> <td> <dateformat date="{new Date(when)}" format="dd MMM yyyy - h:mm a"></dateformat> </td> <td>{expected_duration}</td> <td>{venue}</td> <td>{status}</td> <td> <button onclick="{viewmore}" class="btn btn-sm btn-default">View More </button> </td> </tr> </tbody> </table> </div> <modal title="Appointment Details" name="details" onclose="{true}"> <div class="form-horizontal"> <formstatic label="Appointment For" value="{parent.appointment.name}"></formstatic> <div class="form-group"> <label class="control-label col-sm-4">Booking Type</label> <div class="col-sm-8"> <p show="{!parent.appointment.meta.booktype}" class="form-control-static">Independent/general booker</p> <p show="{parent.appointment.meta.booktype==\'SIU\'}" class="form-control-static">Stockport Interpreting Unit (SIU)</p> <p show="{parent.appointment.meta.booktype==\'NHS\'}" class="form-control-static">Stockport NHS Foundation Trust</p> </div> </div> <formstatic show="{parent.appointment.meta.booktype==\'NHS\'}" label="Out of Hours" value="{parent.appointment.meta.outofhours}"></formstatic> <formstatic label="Service Requested" value="{parent.service(parent.appointment.service)}"></formstatic> <formstatic label="Gender Preference" value="{parent.appointment.gender}"></formstatic> <div class="form-group"> <label class="control-label col-sm-4">When</label> <div class="col-sm-8"> <p class="form-control-static"> <dateformat date="{new Date(parent.appointment.when)}" format="dd MMM yyyy - h:mm a"></dateformat> </p> </div> </div> <formstatic label="Approx Duration" value="{parent.appointment.expected_duration}"></formstatic> <formstatic label="Venue Address" value="{parent.appointment.venue}"></formstatic> <formstatic label="Venue Postcode" value="{parent.appointment.postcode}"></formstatic> <formstatic label="Appointment Type" value="{parent.appointment.type}"></formstatic> <formstatic label="Appointment Description" value="{parent.appointment.description}"></formstatic> <hr> <div class="row"> <div class="col-xs-4 text-right"> <h4>Booked By</h4> </div> </div> <formstatic label="Forename" value="{parent.appointment.first_name}"></formstatic> <formstatic label="Surname" value="{parent.appointment.surname}"></formstatic> <formstatic label="Department" value="{parent.appointment.meta.department}"></formstatic> <formstatic label="PO Number" value="{parent.appointment.meta.po_number}"></formstatic> <formstatic label="Cost Centre Code" value="{parent.appointment.meta.cost_center_code}"></formstatic> <hr> <div if="{!parent.appointment.interpreter_id &amp;&amp; parent.appointment.status!=\'Booking Cancelled\'}"> <p>Clicking accept below will email MDC and the client with a confirmation email and change the booking status to confirmed.</p> <p>Clicking decline will remove this invite from your list</p> <div class="btn-toolbar"> <div onclick="{parent.accept}" __disabled="{isSaving}" class="btn btn-success">Accept Booking</div> <div onclick="{parent.decline}" __disabled="{isSaving}" class="btn btn-danger"> Decline Booking</div> </div> </div> <div if="{parent.appointment.interpreter_id==parent.userid &amp;&amp; new Date(parent.appointment.when) &gt; new Date()}" class="alert alert-success"> <p>The booking has now been assigned to you.</p> </div> <div if="{parent.appointment.interpreter_id &amp;&amp; parent.appointment.interpreter_id!=parent.userid}" class="alert alert-info"> <p>The booking has already been accepted by another interpreter. It will be removed from your list in the next 24 hrs.</p> </div> <div if="{parent.appointment.status==\'Booking Cancelled\'}"> <div class="alert alert-danger"> <p>This booking has been cancelled</p> </div> </div> <div if="{new Date(parent.appointment.when) &lt; new Date()}"> <div class="alert alert-success"> <p>Booking Completed</p> </div> <p>Now the booking has been completed, you need to upload you invoice and timesheets using the tools below</p> <uploadbutton on-click="{parent.handleInvoice}" class="btn btn-default">Upload Invoice <span show="{parent.parent.hasInvoice}" class="fa fa-check"> </span><span show="{parent.parent.uploadingInvoice}" class="fa fa-refresh fa-spin"> </span></uploadbutton> <uploadbutton on-click="{parent.handleTimesheet}" class="btn btn-default">Upload Timesheet <span show="{parent.parent.hasTimesheet}" class="fa fa-check"></span><span show="{parent.parent.uploadingTimesheet}" class="fa fa-refresh fa-spin"> </span></uploadbutton> </div> </div> </modal>', '', '', function(opts) {
var xhr;

xhr = require("../libs/xhr.coffee");

this.services = require("../libs/service-list.coffee");

this.on('mount', function() {
  this.userid = document.querySelector("loginbar").getAttribute("userid");
  this.appointments = null;
  if (window.location.search.match(/editmode=/)) {
    return this.root.innerHTML = "<div style='border:2px dashed #a00'>Appointments Component</div>";
  } else {
    this.toaster = document.querySelector('toaster');
    return this.load();
  }
});

this.load = (function(_this) {
  return function() {
    return xhr("GET", '/duocms/api/appointments/interpreter', null, function(res) {
      _this.appointments = res.body.data;
      return _this.update();
    });
  };
})(this);

this.viewmore = (function(_this) {
  return function(e) {
    var er;
    _this.isSaving = false;
    _this.appointment = e.item;
    if (_this.appointment.files) {
      _this.hasTimesheet = (_this.appointment.files.filter(function(f) {
        return f.match(/timesheet/);
      })).length;
      _this.hasInvoice = (_this.appointment.files.filter(function(f) {
        return f.match(/invoice/);
      })).length;
    }
    try {
      _this.appointment.meta = JSON.parse(_this.appointment.meta);
    } catch (error) {
      er = error;
      console.log(er);
    }
    _this.update();
    return _this.tags.details.show();
  };
})(this);

this.service = (function(_this) {
  return function(val) {
    var found, ref;
    found = _this.services.filter(function(s) {
      return s.value === val;
    });
    return (found != null ? (ref = found[0]) != null ? ref.label : void 0 : void 0) || "";
  };
})(this);

this.accept = (function(_this) {
  return function() {
    var id;
    id = _this.appointment.id;
    _this.update({
      isSaving: true
    });
    return xhr("POST", '/duocms/api/appointments/' + id + '/accept', null, function(res) {
      if (res.body.status !== "success") {
        _this.toaster.trigger('add', {
          title: 'Failed',
          message: res.body.message || "There was an error updating the booking",
          type: 'error'
        });
        _this.load();
      } else {
        _this.toaster.trigger('add', {
          title: 'Successful',
          message: res.body.message || "The booking has been updated",
          type: 'success'
        });
        _this.appointments = _this.appointments.map(function(a) {
          if (+a.id !== +id) {
            return a;
          }
          return res.body.data;
        });
      }
      _this.tags.details.hide();
      _this.isSaving = false;
      return _this.update();
    });
  };
})(this);

this.decline = (function(_this) {
  return function() {
    var id;
    id = _this.appointment.id;
    _this.update({
      isSaving: true
    });
    return xhr("POST", '/duocms/api/appointments/' + id + '/decline', null, function(res) {
      _this.appointments = _this.appointments.filter(function(a) {
        return +a.id !== +id;
      });
      _this.tags.details.hide();
      _this.isSaving = false;
      return _this.update();
    });
  };
})(this);

this.handleInvoice = (function(_this) {
  return function(files) {
    _this.uploadingInvoice = true;
    _this.update();
    return _this.uploadFile(files[0], "invoice", function(res) {
      _this.uploadingInvoice = false;
      if (res.status === 200) {
        _this.hasInvoice = true;
        _this.toaster.trigger('add', {
          title: 'Success',
          message: "Invoice uploaded successfully",
          type: 'success'
        });
      } else {
        _this.toaster.trigger('add', {
          title: 'Failed',
          message: res.body.message || "There was an error uploading your invoice",
          type: 'error'
        });
      }
      return _this.update();
    });
  };
})(this);

this.handleTimesheet = (function(_this) {
  return function(files) {
    _this.uploadingTimesheet = true;
    _this.update();
    return _this.uploadFile(files[0], "timesheet", function(res) {
      _this.uploadingTimesheet = false;
      if (res.status === 200) {
        _this.hasTimesheet = true;
        _this.toaster.trigger('add', {
          title: 'Success',
          message: "Timesheet uploaded successfully",
          type: 'success'
        });
      } else {
        _this.toaster.trigger('add', {
          title: 'Failed',
          message: res.body.message || "There was an error uploading your timesheet",
          type: 'error'
        });
      }
      return _this.update();
    });
  };
})(this);

this.uploadFile = (function(_this) {
  return function(file, type, cback) {
    var formData, self;
    formData = new FormData();
    formData.append("id", _this.appointment.id);
    formData.append("file", file);
    formData.append("type", type);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/appointment/upload?_csrf=' + window.csrf, true);
    self = _this;
    xhr.onload = function() {
      var resp;
      resp = JSON.parse(this.response);
      return cback({
        status: this.status,
        body: resp
      });
    };
    return xhr.send(formData);
  };
})(this);
});
    
  